import { render, staticRenderFns } from "./DataRole.vue?vue&type=template&id=6352586a&scoped=true"
import script from "./DataRole.vue?vue&type=script&lang=js"
export * from "./DataRole.vue?vue&type=script&lang=js"
import style0 from "./DataRole.vue?vue&type=style&index=0&id=6352586a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6352586a",
  null
  
)

export default component.exports